import { makeStyles } from 'tss-react/mui';

const useStylesFieldText: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldText: {
    width: '100%',
    minWidth: '50px !important',
    '& > div': {
      minHeight: 40,
      '& > input, textarea': {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 7,
        paddingBottom: 7,
        fontSize: 14,
      },
    },
  },
  fieldTextBordered: {
    '& > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
    '& input, textarea': {
      background: theme.palette.background.default,
    },
  },
  fieldTextOutlined: {
    '& > div > input, textarea': {
      backgroundColor: theme.palette.background.default,
      paddingLeft: 14,
      paddingRight: 14,
      paddingTop: 16.5,
      paddingBottom: 16.5,
    },
  },
  fieldTextLimited: {
    maxWidth: 300,
  },
  fieldTextBold: {
    '& > div > input': {
      fontWeight: 500,
    },
  },
  fieldTextNoUnderline: {
    '& > div': {
      '&:before, &:after': {
        content: '""',
      },
      '&:before': {
        display: 'none',
      },
      '&:after': {
        display: 'none',
      },
      '& > div > input, & > div > textarea': {
        paddingTop: 5,
        paddingBottom: 5,
      },
    },
  },
  fieldTextLight: {
    '& > div > input': {
      color: theme.palette.common.white,
    },
  },
  fieldTextUnderline: {
    '& > div': {
      minHeight: 41,
    },
  },
  fieldTextUnderlineLight: {
    '& > div:before, & > div:after': {
      borderBottom: `1px solid ${theme.palette.common.white} !important`,
    },
  },
  fieldTextHidden: {
    display: 'none !important',
  },
  fieldTextMultiline: {
    '& textarea': {
      minHeight: 20,
      resize: 'vertical !important',
    },
  },
}));

export default useStylesFieldText;
